import React from 'react';
import CreateTable from '../../components/DataTable';

export default function BusinessParamForm(props) {
    //const [iva, setIva] = useState('');
    //const [ivaId, setIvaId] = useState('');
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            {/*<div className="card-header">
                                <td className="project-actions text-right">
                                    <button className="btn btn-primary btn-sm" onClick={props.handledNew}>
                                        <i className="fas fa-save"></i> Nueva tarifa
                                    </button>
                                </td>
                            </div>*/}
                            <div className="card-body">
                                <div className="col-md-12">
                                    <CreateTable data={props.paramInfoData} handledEdit={props.handledEdit} title={'Tarifas y tipos de pago'} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
